import { useEffect, useRef } from 'react'
import { getTelegramWebApp } from './telegram'

/**
 * Системная кнопка «назад» Telegram — та же команда, что у стрелки в шапке.
 * Видна, пока открыт экран со стрелкой; на вкладках её убираем, иначе
 * Telegram закрыл бы по ней приложение. Вне Telegram ничего не делает.
 *
 * @param onBack что делать при нажатии; читается из ref, чтобы не переподписываться
 */
export function useBackButton(onBack: () => void): void {
  const handler = useRef(onBack)
  handler.current = onBack

  useEffect(() => {
    const button = getTelegramWebApp()?.BackButton
    if (!button) return

    const call = () => {
      handler.current()
    }
    button.onClick(call)
    button.show()

    return () => {
      button.offClick(call)
      button.hide()
    }
  }, [])
}
